import { POLICIES_BASE_URL, POLICYHUB_BASE_URL } from 'config/env';
import { getScriptInfo } from 'global-utils/get-attributes';
import { sanitizeSegment, toSafeUrl } from 'global-utils/url-utils';

// Builds an internal policy URL from our own configured base URL.
const buildInternalPolicyUrl = (
  lang: string,
  prjMarket: string,
  prjId: string,
  path = ''
) => {
  const safeLang = sanitizeSegment(lang);
  const safePrjMarket = sanitizeSegment(prjMarket);
  const safePrjId = sanitizeSegment(prjId);

  if (!safeLang || !safePrjMarket || !safePrjId) {
    return null;
  }

  return toSafeUrl(
    `${POLICIES_BASE_URL}/externals/${safeLang}-${safePrjMarket}${path}?id=${safePrjId}`
  );
};

// Builds an internal PolicyHub URL from our static config.
const buildInternalPolicyHubUrl = (path = '') => {
  return toSafeUrl(`${POLICYHUB_BASE_URL.trim()}${path}`);
};

export const getPoliciesUrl = (
  lang: string,
  prjMarket: string,
  prjId: string
) => {
  if (!prjId || !prjMarket) {
    console.error(`cbgCConsent:the plugin was unable to determine the cookies or privacy notification URL. 
    {{data-prj-id}} or {{data-market}} attributes are missing on the cbgCompPack script. Please fix this issue. 
    Default policies link will be presented instead
    `);
  }

  const { policyPage, cookiesPage } = getScriptInfo();
  const customPoliciesUrl = toSafeUrl(policyPage);
  const customCookiesUrl = toSafeUrl(cookiesPage);
  const policiesUrl =
    customPoliciesUrl || buildInternalPolicyUrl(lang, prjMarket, prjId);
  const cookiesUrl =
    customCookiesUrl ||
    buildInternalPolicyUrl(lang, prjMarket, prjId, '/cookies');
  const privacyUrl = buildInternalPolicyUrl(lang, prjMarket, prjId, '/privacy');
  const termsUrl = buildInternalPolicyUrl(lang, prjMarket, prjId, '/terms');
  const acceptableUseUrl = buildInternalPolicyUrl(
    lang,
    prjMarket,
    prjId,
    '/acceptable-use'
  );
  const socialMediaUrl = buildInternalPolicyUrl(
    lang,
    prjMarket,
    prjId,
    '/social-media'
  );
  const disclosurePolicyUrl = buildInternalPolicyUrl(
    lang,
    prjMarket,
    prjId,
    '/disclosure-policy'
  );

  const safeLang = sanitizeSegment(lang);
  const speakUpUrl = safeLang
    ? buildInternalPolicyHubUrl(`/speak-up/${safeLang}`)
    : null;

  return {
    policiesUrl,
    cookiesUrl,
    privacyUrl,
    termsUrl,
    acceptableUseUrl,
    socialMediaUrl,
    disclosurePolicyUrl,
    speakUpUrl
  };
};
